{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "intelligence",
  "worksWith": [
    {
      "type": "POWERS",
      "target": "vault",
      "label": "Powers vaultIQ"
    },
    {
      "type": "POWERS",
      "target": "operate",
      "label": "Powers complianceIQ"
    },
    {
      "type": "POWERS",
      "target": "shop",
      "label": "Powers shopIQ and shiftIQ"
    },
    {
      "type": "HOSTS",
      "target": "forge",
      "label": "Hosts BYOM and partner agents"
    }
  ]
}